var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleRight = function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.407 3 5.021 4.623a.516.516 0 0 1 0 .754L6.407 13",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+Cgo8cGF0aCBkPSJNNi40MDY5OCAzTDExLjQyODUgNy42MjMwOEMxMS40OCA3LjY3MTQyIDExLjUyMTEgNy43Mjk4MSAxMS41NDkxIDcuNzk0NjRDMTEuNTc3MiA3Ljg1OTQ3IDExLjU5MTcgNy45MjkzNiAxMS41OTE3IDhDMTEuNTkxNyA4LjA3MDY0IDExLjU3NzIgOC4xNDA1NCAxMS41NDkxIDguMjA1MzZDMTEuNTIxMSA4LjI3MDE5IDExLjQ4IDguMzI4NTggMTEuNDI4NSA4LjM3NjkyTDYuNDA2OTggMTMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cgo8L3N2Zz4K";